import * as e from "react";
import r from "../lib/IconBase.es.js";
import s from "../defs/Scales.es.js";
const o = e.forwardRef((a, c) => /* @__PURE__ */ e.createElement(r, { ref: c, ...a, weights: s }));
o.displayName = "ScalesIcon";
const n = o;
export {
  n as Scales,
  o as ScalesIcon
};
